@if (visible && subscription) {
  <div class="modal-overlay" (click)="close()">
    <div class="modal-panel" (click)="$event.stopPropagation()">

      <!-- Header -->
      <div class="modal-header">
        <div class="modal-header-content">
          <div class="user-avatar-lg" [style.background]="subscription.user.avatarBg">
            @if (subscription.user.avatar) {
              <img
                [src]="subscription.user.avatar"
                [alt]="subscription.user.name"
                class="avatar-img" />
            }
            @if (!subscription.user.avatar) {
              <span>{{ subscription.user.initials }}</span>
            }
          </div>
          <div>
            <h3 class="modal-title">{{ subscription.user.name | titlecase}}</h3>
            <p class="modal-subtitle">{{ subscription.user.email }}</p>
          </div>
        </div>
        <button class="close-btn" (click)="close()">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="modal-body">

        <!-- Status + Plan Row -->
        <div class="badges-row">
          <span class="plan-badge" [ngClass]="getPlanClass(subscription.plan)">
            {{ subscription.plan }}
          </span>
          <span class="status-badge" [ngClass]="getStatusClass(subscription.status)">
            {{ subscription.status }}
          </span>
        </div>

        <!-- Info Grid -->
        <div class="info-grid">
          <div class="info-card">
            <div class="info-icon"><i class="pi pi-dollar"></i></div>
            <div>
              <p class="info-label">Amount</p>
              <p class="info-value">${{ subscription.amount | number: '1.2-2' }} / {{ subscription.billingCycle }}</p>
            </div>
          </div>
          <div class="info-card">
            <div class="info-icon"><i class="pi pi-calendar"></i></div>
            <div>
              <p class="info-label">Start Date</p>
              <p class="info-value">{{ subscription.date }}</p>
            </div>
          </div>
          <div class="info-card">
            <div class="info-icon"><i class="pi pi-sync"></i></div>
            <div>
              <p class="info-label">Next Billing</p>
              <p class="info-value">{{ subscription.nextBillingDate }}</p>
            </div>
          </div>
          <div class="info-card">
            <div class="info-icon"><i class="pi pi-tag"></i></div>
            <div>
              <p class="info-label">Billing Cycle</p>
              <p class="info-value">{{ subscription.billingCycle }}</p>
            </div>
          </div>
        </div>

        <!-- Features -->
        <div class="features-section">
          <h4 class="features-title">
            <i class="pi pi-check-circle"></i> Plan Features
          </h4>
          <ul class="features-list">
            @for (feature of subscription.features; track feature) {
              <li class="feature-item">
                <i class="pi pi-check feature-check"></i>
                {{ feature }}
              </li>
            }
          </ul>
        </div>

        <!-- Subscription ID -->
        <div class="sub-id-row">
          <span class="sub-id-label">Subscription ID</span>
          <code class="sub-id">{{ subscription.id }}</code>
        </div>

      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button class="btn-close-footer" (click)="close()">Close</button>
      </div>

    </div>
  </div>
}
